import React,{Component} from 'react';
import {Link} from 'react-router-dom';
import './Login.css';
import logo from "../../assets/img/logo.png";
import textLogo from "../../assets/img/logotwxt.png";
import { connect } from 'react-redux';
import {adminVerifyOtp,onDismiss} from '../../actions/resetActions';
import SimpleReactValidator from 'simple-react-validator';
import SweetAlert from 'sweetalert2-react';

class verifyOtp extends Component {
  constructor(props){
    super(props);
    this.state = {
        otp : '',
    }
    this.validator = new SimpleReactValidator();
  }

  onDismissPopup = () =>{
    this.props.onDismiss();
  }
  componentDidMount() {
    if(!this.props.admin_id && !this.props.otp_res.otp) {
      this.props.history.push("/admin/forgot");
    }
  }

  componentWillReceiveProps(nextProps) {
    if( nextProps.otp_res.admin_id && nextProps.otp_res.otp != null){
       this.props.history.push("/admin/reset");
    }
   }
  


getLoder() {
  let classes = "bt-loader ";
  classes += this.props.loading ? 'bt-show' : 'bt-hide';
  return classes;
}
  verifyOtpSubmit(e)  {
    e.preventDefault();
    if( this.validator.allValid() ){
        this.props.verifyOTP(this.state.otp,this.props.admin_id);
    }
    else {
      this.validator.showMessages();
      this.forceUpdate();
    } 
  } 
    render() {
        return(
              <div className="login-wrapper">
    <div className="container-fluid">
      <div className="row align-items-center">
        <div className="bg-white col-md-6 order-2">
          <div className="login-form-wrapper width-cst">
            <div className="login-box">
              <div className="logo">
                <img src={textLogo} alt="wild" className="img-fluid" />
              </div>
              <div className="login-dis">
                Please enter the OTP here
              </div>

              <form className="form-vertical">
                <div className="form-group">
                  <input type="text" onChange={event => this.setState({otp:event.target.value})}  placeholder="Enter the OTP" className="form-control" />
                  <div className="errorMsg">{this.validator.message('OTP', this.state.otp, 'required')}</div>
                </div>
                <div className="form-group row">

                  <div className="col-md-12">
                    <div className="forgot text-right">
                    <Link className="d-block small" to="/admin/login">Back to home</Link>
                    </div>
                  </div>
                </div>

                <div className="bt-wrapper">
                  <button onClick ={(e)=>this.verifyOtpSubmit(e)} className="waves-effect waves-light btn">Submit</button>
                  <span className={this.getLoder()}></span>
                </div>
              </form>

            </div>
          </div>
        </div>
        <div className="bg-yellow col-md-6 order-1">
          <div className="img-logo width-cst">
            <img src={logo} alt="wild" className="img-fluid" />
          </div>
        </div>
      </div>
        <SweetAlert
        show={ !this.props.status && this.props.popup}
        title="Error"
        type="error"
        text={this.props.message}
        onConfirm={this.onDismissPopup}
        />
    </div>
  </div>
  
        )
    }
}
verifyOtp.deaultProps = {
  error:[],
  otp_res:{}
}
const mapStateToProps = (state) => ({
  loading: state.resetReducer.loading,
  status:state.resetReducer.status,
  popup:state.resetReducer.popup,
  message:state.resetReducer.message,
  admin_id:state.resetReducer.admin_id,
  otp_res:state.resetReducer.otp_res,
  error:state.resetReducer.error
})

const mapDispatchToProps = (dispatch)=> ({
  verifyOTP:(otp,admin_id)=>{
    dispatch(adminVerifyOtp(otp,admin_id))
  },
  onDismiss:()=>{
    dispatch(onDismiss())
  }
})
export default connect(mapStateToProps, mapDispatchToProps)(verifyOtp)




